import PortalLogin from "../components/portalLogin.jsx";
import PortalIndex from "../components/portalIndex.jsx";

import PortalBillingStripe from "../components/portalBillingStripe.jsx";
import PortalSendMagicLink from "../components/portalSendMagicLink.jsx";
import PortalPasswordReset from "../components/portalPasswordReset.jsx";
import PortalPrescriptionRefills from "../components/portalPrescriptionRefills.jsx";
import PortalPrescriptionHistory from "../components/portalPrescriptionHistory.jsx";
import PortalMySubscriptions from "../components/portalMySubscriptions.jsx";

import PortalDoctorMessages from "../components/portalDoctorMessages.jsx";
import PortalPatientCareMessages from "../components/portalPatientCareMessages.jsx";
// import ApolloTest from "../components/apolloTest";

import { chain } from "lodash";

// Name is required here for routeMap lookup
export const portalRoutes = [
  {
    name: "login",
    path: "/me/login",
    component: PortalLogin,
    public: true,
  },
  {
    name: "magicLinkLogin",
    path: "/me/login-send-email",
    component: PortalSendMagicLink,
    public: true,
  },
  {
    name: "magicLinkLoginSMS",
    path: "/me/login-send-sms",
    component: PortalSendMagicLink,
    public: true,
    componentProps: { sms: true },
  },
  {
    name: "passwordReset",
    path: "/me/password-reset",
    component: PortalPasswordReset,
    public: true,
  },
  {
    name: "patientPortalIndex",
    path: "/me/portal",
    component: PortalIndex,
    // public: true,
  },
  {
    // redirect to stripe payment portal
    name: "paymentPortal",
    path: "/me/payment-portal",
    component: PortalBillingStripe,
  },
  {
    name: "mySubscriptions",
    path: "/me/my-subscriptions",
    component: PortalMySubscriptions,
  },
  {
    name: "doctorMessages",
    path: "/me/messages/doctor",
    component: PortalDoctorMessages,
  },
  {
    name: "patientCareMessages",
    path: "/me/messages/care",
    component: PortalPatientCareMessages,
  },
  {
    name: "refills",
    path: "/me/refills",
    component: PortalPrescriptionRefills,
  },
  {
    name: "history",
    path: "/me/history",
    component: PortalPrescriptionHistory,
  },
  {
    name: "redirectRootToPatientPortalIndex",
    path: "/me",
    pathTo: "/me/portal",
    redirect: true,
  },

  // {
  //   path: "/me/apollo",
  //   name: "Apollo Test",
  //   component: ApolloTest
  // }
  // {
  //   path: "/visits/signup-details",
  //   name: "Signup Details",
  //   short: "Sign Up Details",
  //   mini: "SUD",
  //   // icon: PersonAdd,
  //   component: SignUpDetails
  // }
];

// Generate route map
export const routeMap = chain(portalRoutes)
  .keyBy("name")
  .mapValues("path")
  .value();
// console.log("routeMap:", routeMap);
